import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { CheckCircleOutlined } from '@ant-design/icons';
import { LocaleString } from '@nackle/intl-tools';
import _ from 'lodash';

export function Bubbles( props ) {
  return (
    <>
      <div className="bubbles">
        { _.times( 10, ( i ) => (
          <div key={ i } className="bubble"></div>
        ) ) }
      </div>
    </>
  );
}

export default function Success( props ) {
    const { forward } = props;
    const [ animate, setAnimate ] = useState( false );
    
    useEffect( () => {
      setAnimate( true );
    }, [] );

   
    return (
        <CSSTransition
        timeout={ 1000 }
        in={ animate }
        classNames={ forward ? 'slide-in' : 'slide-out' }>
            <div className='success-container'>
                <div style={ { display: 'flex', flexDirection: 'column' } }>
                    <CheckCircleOutlined className='success-icon' style={ { fontSize: '117px' } } />
                    <div className='message'>
                        <LocaleString code='recognition.success.message' />
                    </div>
                </div>
                <div className='bubble-container'>
                    <Bubbles />
                </div>
            </div>
        </CSSTransition>
    );
}
